<template>
  <div class="intelligentIndustry2-page">
		<div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner intelligentIndustry2_banner">
			<div class="bodyinfo" style="text-align: left;">
				<h2>智能工业</h2>
				<p>该系统由三部分组成：高压测温探测器、高温监测网关、人机接口单元构成</p>
				<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
			</div>
		</div>
		<div>
			<div class="intelligentIndustry2_body">
        <div class="" style=" background: #FFFFFF; padding-top: 150px;">
          <div class="caseDetails-center-content-container" style="width: 70%; margin: 0 auto;">
            <p class="introduce-item-title">案例介绍</p>
            <p class="introduce-item-describe" style="text-align: left; color: #344455; line-height: 36px;">中波广播的发射关键部件（ 电容、电感，输出馈筒大电流端子等 ）在工作过程中存在工作温升，该温升过高后直接影响发射机正常工作，造成停机停播问题。而现有手段无法直观测量温升情况，无法提前进行干预，通过无线测量技术，实现在发射机工作时，实时在线监测核心部件的工作温度，提前进行超温报警，保障安全播出工作的正常进行，该系统由三部分组成：高压测温探测器、高温监测网关、人机接口单元构成。</p>
          </div>
        </div>
				<div class="intelligentIndustry21">
					<img class="img1" src="../../assets/img/caseDetails/intelligentIndustry2/default_img9.png" style="margin-left: -26%;">
				</div>
				<div class="intelligentIndustry22 intelligentIndustry2_bg">
					<span class="span1">温度趋势图</span>
					<span class="span2">测温系统</span>
					<img class="img1" src="../../assets/img/caseDetails/intelligentIndustry2/default_img11.png">
					<img class="img2" src="../../assets/img/caseDetails/intelligentIndustry2/default_img10.png">
				</div>
				<div class="intelligentIndustry23">
					<span class="span2">超温报警</span>
					<img class="img1" src="../../assets/img/caseDetails/intelligentIndustry2/default_img12.png">
					<img class="img2" src="../../assets/img/caseDetails/intelligentIndustry2/default_img14.png" style="width: 19%; margin-left: 20%; top: 260px;">

				</div>
			</div>	
		</div>	
		<Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'intelligentIndustry2',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  /* @import '../../html/css2/zkm.css';
  @import '../../html/css2/zkm.market.css'; */
  /* 说明，上面的两个css，在另一个页面页同样引入了，但是会报错误，原因未知 */
</style>